var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "ID",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.policy.PolicyMasterID,
                          callback: function($$v) {
                            _vm.$set(_vm.lead.policy, "PolicyMasterID", $$v)
                          },
                          expression: "lead.policy.PolicyMasterID"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Code",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.policy.PolicyMasterCode,
                          callback: function($$v) {
                            _vm.$set(_vm.lead.policy, "PolicyMasterCode", $$v)
                          },
                          expression: "lead.policy.PolicyMasterCode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Status",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.policy.Status,
                          callback: function($$v) {
                            _vm.$set(_vm.lead.policy, "Status", $$v)
                          },
                          expression: "lead.policy.Status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Commencement",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.policy.CommencementDate,
                          callback: function($$v) {
                            _vm.$set(_vm.lead.policy, "CommencementDate", $$v)
                          },
                          expression: "lead.policy.CommencementDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Will Status",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.policy.WillStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.lead.policy, "WillStatus", $$v)
                          },
                          expression: "lead.policy.WillStatus"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("h3", [_vm._v("Plan details")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Product",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.policy.plan_details.product_name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.lead.policy.plan_details,
                              "product_name",
                              $$v
                            )
                          },
                          expression: "lead.policy.plan_details.product_name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Plan",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.policy.plan_details.product_plan,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.lead.policy.plan_details,
                              "product_plan",
                              $$v
                            )
                          },
                          expression: "lead.policy.plan_details.product_plan"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c(
                        "v-currency-field",
                        _vm._b(
                          {
                            staticClass: "title-branding custom-input",
                            attrs: {
                              label: "Premium",
                              type: "tel",
                              filled: "",
                              readonly: ""
                            },
                            model: {
                              value: _vm.lead.policy.plan_details.premium,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.lead.policy.plan_details,
                                  "premium",
                                  $$v
                                )
                              },
                              expression: "lead.policy.plan_details.premium"
                            }
                          },
                          "v-currency-field",
                          _vm.$root.currency_config,
                          false
                        )
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c(
                        "v-currency-field",
                        _vm._b(
                          {
                            staticClass: "title-branding custom-input",
                            attrs: {
                              label: "Value to beneficiaries",
                              type: "tel",
                              filled: "",
                              readonly: ""
                            },
                            model: {
                              value:
                                _vm.lead.policy.plan_details
                                  .value_beneficiaries_total,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.lead.policy.plan_details,
                                  "value_beneficiaries_total",
                                  $$v
                                )
                              },
                              expression:
                                "lead.policy.plan_details.value_beneficiaries_total"
                            }
                          },
                          "v-currency-field",
                          _vm.$root.currency_config_no_decimals,
                          false
                        )
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }